import { render, staticRenderFns } from "./CardDiscipline.vue?vue&type=template&id=b61d2822&scoped=true"
import script from "./CardDiscipline.vue?vue&type=script&lang=js"
export * from "./CardDiscipline.vue?vue&type=script&lang=js"
import style0 from "../styles/CardDiscipline.css?vue&type=style&index=0&id=b61d2822&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b61d2822",
  null
  
)

export default component.exports